<script lang="ts" setup>
import { computed } from 'vue';

// Icons
import { XCircleIcon } from '@heroicons/vue/solid';

interface Props {
  data?: {
    status: number;
    errors: Array<{
      message: string;
      field: string;
      indexes: [];
      params: [];
    }>;
  };
}

const props = defineProps<Props>();

const grouped_message = computed(() => {
  if (props.data && props.data.errors && props.data.errors.length === 1) {
    return props.data.errors[0].message;
  } else {
    return 'internal_error';
  }
});

const getFields = (e: { message: string; field: string; indexes: []; params: [] }) => {
  const fields: string[] = [];

  if (e.field !== '') {
    fields.push(e.field);
  }
  if (!e.params) {
    e.params = [];
  }

  return [...fields, ...e.params];
};
</script>

<template>
  <Transition name="top-fade">
    <div v-if="data" class="mt-[4px] bg-red-100 p-[8px] rounded-[8px] flex items-center gap-[8px] z-[1]">
      <div class="flex items-center">
        <div class="flex-shrink-0">
          <XCircleIcon class="h-[16px] text-red" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <h3 class="text-12 font-semibold text-red">Er heeft zich een fout voorgedaan. Neem contact op met <a href="mailto:hey@hajee.be" class="underline hover:no-underline">hey@hajee.be</a>.</h3>
          <!--<h3 class="text-12 font-semibold text-red">{{ grouped_message }}</h3>
          <div v-if="data.errors.length > 1" class="text-12 font-semibold text-red">
            <ul role="list" class="pl-5 space-y-1 list-disc">
              <li v-for="e in data.errors">{{ e.message }}</li>
            </ul>
          </div>-->
        </div>
      </div>
    </div>
  </Transition>
</template>
